<template>
    <div id="wrap" class="skpfull_wrap">
		<div class="main-inner" role="main">
			<div class="container">
				<div class="title terms-button">			
					<h1>{{docTitle}}</h1>
				</div>
				<div class="content">
					<div class="one-terms">
						<div class="terms-detail" v-html="docContents">
                        </div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import Vue              from 'vue';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import qs               from 'query-string';
import axios            from 'axios';

export default {
    data() {
        return {
            loginCountryCd: '',
            languageCd: '',
            srchLangCd: '',
            docTitle: '',
            docContents: ''
        };
    },
    computed: {
    },
    methods: {
        loadContentsByCountry() {
            const params = {countryCd: this.loginCountryCd, srchLangCd: this.srchLangCd};
            const url = `${SDLUtil.API_URL}/noauth/eur/getTermsCondByCountry.skp`;
            axios.post(url, qs.stringify(params))
                 .then(resp => {
                    console.log('Terms.resp ===> ', resp);
                    this.docTitle    = resp.data.TITLE;
                    this.docContents = resp.data.CONTENTS;
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                }
            );
        }
    },
    created() {
    },
    mounted() {
        this.loginCountryCd = localStorage.getItem('eur.user.country.code');
        this.languageCd = localStorage.getItem('eur.user.lang.code');
        
        const countryCds = ['FR', 'DE', 'CY', 'GR', 'IT', 'MT', 'PT', 'ES', 'CH', 'SK', 'CZ', 'AT', 'PL', 'HU'];
        const SEB  = ['LT', 'LV'];
        const SEAD = ['BA', 'HR', 'ME', 'MK', 'RS', 'SI', 'XK'];
        const SENA = ['FI', 'IS', 'NO', 'SE'];
        const SEBN = ['BE', 'LU', 'NL'];

        if (SEB.includes(this.loginCountryCd))              this.loginCountryCd = 'EE';
        else if (SEAD.includes(this.loginCountryCd))        this.loginCountryCd = 'AL';
        else if (SENA.includes(this.loginCountryCd))        this.loginCountryCd = 'DK';
        else if (SEBN.includes(this.loginCountryCd))        this.loginCountryCd = 'BE';
        else if ('RO' == this.loginCountryCd)               this.loginCountryCd = 'BG';
        else if (!countryCds.includes(this.loginCountryCd)) this.loginCountryCd = 'GB';

        const CH_LANGS = ['de', 'fr', 'it'];
        if (this.loginCountryCd == 'CH') {
            if (!CH_LANGS.includes(this.languageCd)) this.srchLangCd = 'en';
            else                                     this.srchLangCd = this.languageCd;
        }
        this.loadContentsByCountry();
    },
};
</script>

<style scoped>
html /deep/ {
    @import url('/static/css/user.css');
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/AgreeViewTermsCondt.vue